import React from "react";
import { Link } from "react-router-dom";
import { Box, Button, Col, Flex, Gap, InputField, Row,  Typography } from "../../ppui";
import { MdOutlineMailOutline } from "react-icons/md";
import LoginImg from "../../assets/image/login-bg.jpeg";
import Logo from "../../assets/svgs/logo";
import styled from "styled-components";
import { theme } from "../../theme";
import { Brand, FooterBox, FromBox } from "../registration/style";


const ScreenLayout = styled.section({
       position: "fixed",
       height: "100%",
       width: "100%",
       overflow: "hidden",
       display: "flex",
       alignItems: "center",
       justifyContent: "flex-start",
       padding: "1.25rem",
       gap: "4.813rem",
       backgroundColor: theme.colors.light.light,
       "@media (max-width: 600px)": {
        // display: "none",
       },
     });
     const ImageBox = styled.div({
       height: "100%",
       width: "45%",
       maxWidth: "50rem",
       overflow: "hidden",
       display: "flex",
       alignItems: "center",
       justifyContent: "center",
       borderRadius: theme.radius.card,
       "& img": { width: "100%", height: "100%", objectFit: "cover" },
       "@media (max-width: 992px)": {
        display: "none",
       },
     });
     const ContentWrapper = styled(Flex)({
       height: "100%",
       width: "55%",
       flexGrow: 1,
       overflow: "hidden",
       flexDirection: "column",
       justifyContent: "space-between",
     });
    
     const Gap30 = styled(Box)({ height: "1.875rem" });
    

const ForgotPassword = () => {
  return (
    <>
      <ScreenLayout>
        <ImageBox>
          <img src={LoginImg} alt="" />
        </ImageBox>
        <ContentWrapper>
          <Brand>
            <Logo />
          </Brand>
          <FromBox>
            <Typography variant="h3">Reset Password</Typography>
            <Typography variant="body2" color="dark" colorVariant="light">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
              massa lacus, finibus vel tincidunt non, malesuada non turpis.
              Aenean et faucibus metus, vitae lacinia metus.
            </Typography>
            <Gap30 />
            <form>

              <Box pb={22}>
                <InputField
                  type="email"
                  label="Enter Your Email"
                  variant="standard"
                  required={true}
                  placeholder="Email"
                  fullWidth
                  labelBold
                  prefix={<MdOutlineMailOutline />}
                />
              </Box>



              <Gap height={10}/>
              <Row>
              <Col md={4}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    block
                    fullWidth
                  >
                    Submit
                  </Button>
                </Col>
                {/* <Col sm={12}>
                <Typography variant="h6" mt={15} mb={2}>Back To Login</Typography>
                  <Button
                    type="submit"
                    variant="text"
                    color="primary"
                    block
                    fullWidth
                  >
                    Login
                  </Button>
                </Col> */}
              </Row>

              <Gap height={"20"} />
              <Typography align="left" variant="body2" mt={"2"}>
               Back To Login
                <Link to="/"> Login</Link>
              </Typography>



            </form>
          </FromBox>
          <FooterBox>
            <Typography variant="body2" color="dark" colorVariant="light">
              For more detailed information please review our
              <Link color="dark" underline="always" to="/">
                Privacy Policy.
              </Link>
              Need help?{" "}
              <Link color="dark" underline="always" to="/">
                Contact us
              </Link>
            </Typography>
          </FooterBox>
        </ContentWrapper>
      </ScreenLayout>
    </>
  );
};

export default ForgotPassword;
